module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAASCAYAAABB7B6eAAAAcElEQVR4AeySsQ2AQAwDHYPEHKzBnszHGiCQgr+Dgv/KVC/5KiexlIQAdiNnCZgU4GIsAZrvUw9o7pabSpwwFeCkH1kLrounfCec14ATDkvCCUM/6uSHN83QmStq+ZXWYhHMA4FvWv6jNxCvOQFcNwAAAP//ne/4sQAAAAZJREFUAwDLC76hwOz9wAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/deutsch.png
// module id = xUhY
// module chunks = 2